import styled from 'styled-components';
import { palette } from '@m12s/component-library';
import { zLayer } from 'lib/utils/styled';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zLayer.loading};
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${palette.Grey100};
`;

export const TitleText = styled.p`
  font-weight: 600;
  font-size: 1.25rem;
  margin-top: 1rem;
  margin-bottom: 0;
  text-align: center;
`;

export const SubtitleText = styled.p`
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
  text-align: center;
`;
